import { AGENT_MODEL, TestMode } from '@nrwl/common-lib';
import { FtpConfigFieldMapping, testTypeValue } from '../models/models';

export const FTP_AGENT_MODEL_CONFIG = {
  id: 'ftp_test',
  agentConfig: {
    default: {
      setup: {
        //setup page model
        alias: {
          enabled: true,
          value: 'FTP',
          outputField: FtpConfigFieldMapping.ALIAS,
          tabId: 'ftp_setup',
          restoreOnAgentChange: true
        },
        customer: {
          enabled: true,
          value: '',
          outputField: 'customer',
          tabId: 'ftp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technician: {
          enabled: true,
          value: '',
          outputField: 'technician',
          tabId: 'ftp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        contact: {
          enabled: true,
          value: '',
          outputField: 'contact',
          tabId: 'ftp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        email: {
          enabled: true,
          value: '',
          outputField: 'email',
          tabId: 'ftp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        phone: {
          enabled: true,
          value: '',
          outputField: 'phone',
          tabId: 'ftp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technicianId: {
          enabled: true,
          value: '',
          outputField: 'technicianId',
          tabId: 'ftp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        comments: {
          enabled: true,
          value: '',
          outputField: 'comments',
          tabId: 'ftp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        runType: {
          enabled: true,
          value: 'on-going',
          outputField: FtpConfigFieldMapping.RUN_TYPE,
          tabId: 'ftp_setup',
          restoreOnAgentChange: true
        },
        scheduler: {
          enabled: true,
          value: { repeatInterval: 0, timeStamp: '', endTime: 90, isValid: true },
          outputField: FtpConfigFieldMapping.SCHEDULER,
          tabId: 'ftp_setup',
          restoreOnAgentChange: true
        },
        engineAInfo: {
          enabled: true,
          value: null,
          outputField: FtpConfigFieldMapping.ENGINE_A_INFO,
          tabId: 'ftp_setup',
          restoreOnAgentChange: true
        },
        engineBInfo: {
          enabled: false,
          value: null,
          outputField: FtpConfigFieldMapping.ENGINE_B_INFO,
          tabId: 'ftp_setup'
        },
        agentType: {
          enabled: true,
          value: 'default',
          outputField: FtpConfigFieldMapping.AGENT_TYPE,
          tabId: 'ftp_setup'
        },
        testMode: {
          enabled: true,
          value: TestMode.MA_TO_SERVER,
          outputField: FtpConfigFieldMapping.TEST_MODE,
          tabId: 'ftp_setup',
          restoreOnAgentChange: true
        },
        direction: {
          enabled: true,
          value: TestMode.UPLOAD,
          outputField: FtpConfigFieldMapping.DIRECTION,
          tabId: 'ftp_setup',
          restoreOnAgentChange: true
        },
        selectedOriginator: {
          enabled: true,
          value: null,
          outputField: FtpConfigFieldMapping.SELECTED_ORIGINATOR,
          tabId: 'ftp_setup',
          restoreOnAgentChange: true
        },
        selectedDestination: {
          enabled: true,
          value: null,
          outputField: FtpConfigFieldMapping.SELECTED_DESTINATION,
          tabId: 'ftp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        type: {
          enabled: true,
          value: testTypeValue.FTP,
          outputField: FtpConfigFieldMapping.TEST_TYPE,
          tabId: 'ftp_setup',
          restoreOnAgentChange: true
        },
        tcpPort: {
          enabled: true,
          value: 0,
          outputField: FtpConfigFieldMapping.TCP_PORT,
          tabId: 'ftp_setup'
        },
        threshold: {
          enabled: true,
          value: true,
          outputField: FtpConfigFieldMapping.THRESHOLD_ENABLED,
          tabId: 'ftp_setup',
          restoreOnAgentChange: true
        },
        uploadThreshold: {
          enabled: true,
          value: 90,
          outputField: FtpConfigFieldMapping.ENGINE_A_TO_B_THRESHOLD,
          tabId: 'ftp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        downloadThreshold: {
          enabled: true,
          value: 90,
          outputField: FtpConfigFieldMapping.ENGINE_B_TO_A_THRESHOLD,
          tabId: 'ftp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        target: {
          enabled: true,
          value: true,
          outputField: FtpConfigFieldMapping.TARGET_ENABLED,
          tabId: 'ftp_setup',
          restoreOnAgentChange: true
        },
        uploadTarget: {
          enabled: true,
          value: 100,
          outputField: FtpConfigFieldMapping.ENGINE_A_TO_B_TARGET,
          tabId: 'ftp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        downloadTarget: {
          enabled: true,
          value: 100,
          outputField: FtpConfigFieldMapping.ENGINE_B_TO_A_TARGET,
          tabId: 'ftp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        uploadExternalURL: {
          enabled: true,
          outputField: FtpConfigFieldMapping.ENGINE_A_TO_B_URL,
          tabId: 'ftp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        downloadExternalURL: {
          enabled: true,
          outputField: FtpConfigFieldMapping.ENGINE_B_TO_A_URL,
          tabId: 'ftp_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        }
      },

      running: {
        add: 'anything that is different between agents in running view'
      },

      final: {
        add: 'anything that is different between agents in final report'
      },
      modes: {
        [TestMode.MA_TO_SERVER]: {
          setup: {
            uploadExternalURL: { enabled: false },
            downloadExternalURL: { enabled: false }
          }
        }
        // [TestMode.MA_TO_EXTERNAL]: {
        //   setup: {
        //     engineBInfo: { enabled: false },
        //     uploadExternalURL: { enabled: true },
        //     downloadExternalURL: { enabled: true }
        //   }
        // }
      }
    },
    [AGENT_MODEL.VTA]: {
      setup: {
        runExclusive: { enabled: true },
        engineBInfo: { enabled: true }
      },
      modes: {
        [TestMode.MA_TO_SERVER]: {
          setup: {
            engineBInfo: { enabled: true },
            uploadExternalURL: { enabled: false },
            downloadExternalURL: { enabled: false }
          }
        }
        // [TestMode.MA_TO_EXTERNAL]: {
        //   setup: {
        //     engineBInfo: { enabled: false },
        //     uploadExternalURL: { enabled: true },
        //     downloadExternalURL: { enabled: true }
        //   }
        // }
      }
    },
    [AGENT_MODEL.VSPA_SAT]: {
      setup: {
        runExclusive: { enabled: true },
        engineBInfo: { enabled: true }
      },
      modes: {
        [TestMode.MA_TO_SERVER]: {
          setup: {
            engineBInfo: { enabled: true },
            uploadExternalURL: { enabled: false },
            downloadExternalURL: { enabled: false }
          }
        }
      }
    }
  }
};
